module.exports = __webpack_public_path__ + "static/media/KSMS_2026_PDF.20ef7b2a.pdf";